import { splitsList } from '../constants';

export default function isFlexUser(split) {
  const splitEnabled = Boolean(split?.treatments?.[splitsList.isFlexSplitEnabled]);

  return splitEnabled;
}
